import React, { useState } from "react";
import styles from "../styles/ChatbotPanel.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faTimesCircle } from "@fortawesome/free-solid-svg-icons";

export default function ChatbotPanel({ onClose }) {
  const topics_old = [
    "Land Acquisition Act",
    "Town Planning Act",
    "Development Control Rules",
    "FSI & TDR Rules"
  ];

    const topics = [
    "MRTP Act",
    "UDCPR",
    "ULC",
    "Land Acquisition",
    "Valuation Guidelines",
  ];

  const [messages, setMessages] = useState([
    {
      sender: "bot",
      text: "👋 Welcome! Please select a topic first:",
    },
  ]);

  const [selectedTopic, setSelectedTopic] = useState(null);
  const [input, setInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // ✅ Handle Topic Selection
  const handleTopicSelect = (topic) => {
    setSelectedTopic(topic);

    setMessages((prev) => [
      ...prev,
      { sender: "user", text: topic },
      {
        sender: "bot",
        text: `✅ Topic selected: ${topic}\nNow ask your question.`,
      },
    ]);
  };

  // ✅ Send Question
  const handleSend = async () => {
    if (!input.trim() || !selectedTopic) return;

    const userMessage = { sender: "user", text: input };
    setMessages((prev) => [...prev, userMessage]);

    const query = input;
    const topic = selectedTopic;

    setInput("");
    setIsLoading(true);

    try {
      const res = await fetch(
        "https://tph-api-server.vishvaconnect.site/chatbot6.php",
        //"http://localhost/Products/TPH_app/server/chatbot5.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ query, topic }), // ✅ send topic also
        }
      );

      const data = await res.json();

      const botMessage = {
        sender: "bot",
        text: data.answer || "No answer found.",
        source: data.source || null,
        link: data.link || "#",
      };

      setMessages((prev) => [...prev, botMessage]);
    } catch (error) {
      setMessages((prev) => [
        ...prev,
        {
          sender: "bot",
          text: "⚠️ Server error. Try again.",
        },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.chatbotContainer}>
      <div className={styles.chatHeader}>
        <h3>TP Chatbot</h3>
        <FontAwesomeIcon
          icon={faTimesCircle}
          className={styles.closeIcon}
          onClick={onClose}
        />
      </div>

      <div className={styles.chatBody}>
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`${styles.message} ${
              msg.sender === "user" ? styles.userMessage : styles.botMessage
            }`}
          >
            <p>{msg.text}</p>
          </div>
        ))}

        {/* ✅ Show Topic Buttons */}
        {!selectedTopic && (
          <div style={{ padding: "10px" }}>
            {topics.map((topic, i) => (
              <button
                key={i}
                onClick={() => handleTopicSelect(topic)}
                style={{ margin: "5px", padding: "8px" }}
              >
                {topic}
              </button>
            ))}
          </div>
        )}

        {isLoading && <p>Typing...</p>}
      </div>

      {selectedTopic && (
        <div className={styles.chatInputArea}>
          <input
            type="text"
            placeholder="Ask your question..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
          />
          <button onClick={handleSend} disabled={isLoading}>
            <FontAwesomeIcon icon={faPaperPlane} />
          </button>
        </div>
      )}
    </div>
  );
}